import Link from 'found/Link';
import PropTypes from 'prop-types';
import React from 'react';

import BadgeActiveTimeRange from 'src/components/Badge/BadgeActiveTimeRange';
import Loading from 'src/components/Loading';
import UUID from 'src/components/UUID';

/**
 * Description
 * @param {object} props
 * @param {object} props.meter
 * @returns {React.ReactComponentElement} - AdminPrimaryBillingPointShowMeter component
 */
function AdminPrimaryBillingPointShowMeter({ meter = null }) {
  if (!meter) {
    return <Loading />;
  }

  const {
    uuid, identifier, active, primaryBillingPoint,
  } = meter;
  const { uuid: pbpId, identifier: primaryBillingPointIdentifier } = primaryBillingPoint;

  return (
    <tr>
      <th scope="row" colSpan={2}>
        <Link to={`/admin/meters/${uuid}`}>
          {identifier}
        </Link>
        <br />
        <UUID uuid={uuid} />
      </th>
      <td>
        <BadgeActiveTimeRange active={active} />
      </td>
      <td>
        <Link to={`/admin/primary-billing-points/${pbpId}`}>
          {primaryBillingPointIdentifier}
        </Link>
        <br />
        <UUID uuid={pbpId} />
      </td>
    </tr>
  );
}

AdminPrimaryBillingPointShowMeter.propTypes = {
  meter: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

export default AdminPrimaryBillingPointShowMeter;
